"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoginBtn = function (_React$Component) {
    _inherits(LoginBtn, _React$Component);

    function LoginBtn(props) {
        _classCallCheck(this, LoginBtn);

        var _this = _possibleConstructorReturn(this, (LoginBtn.__proto__ || Object.getPrototypeOf(LoginBtn)).call(this, props));

        _this.state = {};

        return _this;
    }

    _createClass(LoginBtn, [{
        key: "render",
        value: function render() {

            return _react2.default.createElement(
                "button",
                { className: this.props.btnclassName, onClick: this.props.onClick, tabIndex: this.props.tabIndex },
                _react2.default.createElement("img", { src: this.props.img, alt: "" }),
                _react2.default.createElement(
                    "span",
                    { className: "" },
                    _react2.default.createElement("i", { className: this.props.icon, "aria-hidden": "true" })
                ),
                _react2.default.createElement(
                    "span",
                    { className: this.props.spanClassName },
                    this.props.btnText
                )
            );
        }
    }]);

    return LoginBtn;
}(_react2.default.Component);

exports.default = LoginBtn;


//////////////////
// WEBPACK FOOTER
// ./src/components/cart-view/cart-left/LoginBtn.jsx
// module id = 499
// module chunks = 0